import { __assign, __awaiter, __generator } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { PangeaDeleteModal } from "@pangeacyber/react-mui-shared";
import { Button, IconButton } from "@mui/material";
import { useTheme } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useStoreFileViewerContext } from "../../hooks/context";
import { alertOnError } from "../AlertSnackbar/hooks";
var DeleteFileButton = function (_a) {
    var object = _a.object, ButtonProps = _a.ButtonProps, _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b, _c = _a.view, view = _c === void 0 ? "text" : _c;
    var theme = useTheme();
    var _d = useStoreFileViewerContext(), apiRef = _d.apiRef, reload = _d.reload;
    return (_jsx(PangeaDeleteModal, { description: "".concat(object.name || object.id, " and all versions will be permanently removed."), title: "Delete ".concat(object.name || object.id), onDelete: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!apiRef.delete)
                    return [2 /*return*/];
                return [2 /*return*/, apiRef
                        .delete({ id: object.id, force: true })
                        .then(function () {
                        onClose();
                        reload();
                    })
                        .catch(function (err) {
                        alertOnError(err);
                        reload();
                        onClose();
                    })];
            });
        }); }, Button: function (props) {
            return view === "icon" ? (_jsx(IconButton, { onClick: props.onClick, children: _jsx(DeleteIcon, { fontSize: "small", sx: { color: theme.palette.text.primary } }) })) : (_jsx(Button, __assign({ sx: { width: "100%" }, variant: "text", startIcon: _jsx(DeleteIcon, { fontSize: "small" }), onClick: props.onClick }, ButtonProps, { children: "Delete" })));
        } }));
};
export default DeleteFileButton;
